import type {ThemeConfig} from "antd";

export const nlrmTheme: ThemeConfig = {
  token: {
    colorPrimary: "#3157d5",
    colorInfo: "#3157d5",
    colorSuccess: "#16866a",
    colorWarning: "#c77a09",
    colorError: "#c43f4d",
    colorText: "#172033",
    colorTextSecondary: "#657086",
    colorBgLayout: "#f4f7fb",
    colorBorderSecondary: "#e2e8f2",
    borderRadius: 12,
    borderRadiusLG: 16,
    controlHeight: 42,
    fontFamily: '"Microsoft YaHei", "Segoe UI", Arial, sans-serif',
  },
  components: {
    Layout: {bodyBg: "#f4f7fb", headerBg: "rgba(255,255,255,.94)", siderBg: "#142448"},
    Menu: {darkItemBg: "#142448", darkItemSelectedBg: "#3157d5", itemBorderRadius: 10},
    Card: {boxShadowTertiary: "0 12px 36px rgba(38, 67, 125, .08)"},
    Button: {primaryShadow: "0 8px 18px rgba(49,87,213,.18)"},
  },
};

